import useCarouselContext from './CarouselContext';
import { cn } from 'utils/styles';
import { OverflowVisibleSettings } from 'types/constants';

interface CarouselContentProps extends React.HTMLAttributes<HTMLDivElement> {
  overflowVisible?: OverflowVisibleSettings | boolean;
  contentClassName?: string;
}

export const hiddenClass = 'overflow-hidden';
export const visibleClass = 'overflow-visible';
export const visibleVerticalClass = 'overflow-y-visible';
export const visibleHorizontalClass = 'overflow-x-visible';

function CarouselContent({ className, overflowVisible, contentClassName, ...props }: CarouselContentProps) {
  const setOverflow = () => {
    switch (overflowVisible) {
      case OverflowVisibleSettings.All:
        return visibleClass;
      case OverflowVisibleSettings.Desktop:
        return `${hiddenClass} sm:${visibleClass}`;
      case OverflowVisibleSettings.Mobile:
        return `${visibleClass} sm:${hiddenClass}`;
      case OverflowVisibleSettings.MobileVertical:
        return `${visibleVerticalClass} sm:${hiddenClass}`;
      case OverflowVisibleSettings.None:
      default:
        return hiddenClass;
    }
  };

  const { carouselRef } = useCarouselContext();
  const carouselContentClasses = cn(
    setOverflow(),
    'pt-4 -mt-4', // Workaround to allow sup elements to overflow hidden container
    contentClassName,
  );

  return (
    <div className={cn(className)} data-testid="carousel-content">
      <div ref={carouselRef} className={carouselContentClasses} data-testid="carousel-content-inner">
        {props.children}
      </div>
    </div>
  );
}

export default CarouselContent;
